import React, {useContext} from "react"

import firebase from 'firebase/compat/app'
import "firebase/compat/auth";
import "firebase/compat/firestore"


// simple switch returning the config for one one of meddbriefer.orgs firebase projects,
// defaults to 'MedDebriefer' (production)
function getProjectConfig(projectName) {
    switch(projectName) {
        case "PamDev":
            return {
                apiKey: "AIzaSyB9eVT-fu4TOjxHoPAXqsnz9tCcbTJkTOw",
                authDomain: "pamdev-ea800.firebaseapp.com",
                projectId: "pamdev-ea800",
                storageBucket: "pamdev-ea800.appspot.com",
                messagingSenderId: "366450927885",
                appId: "1:366450927885:web:caa5f022ef1de182a0e844",
                measurementId: "G-JC5XZEPYT1"
            };
        case "ScottDev":
            return {
                apiKey: "AIzaSyBEhbIdVW2F2vvvfvpNb2SsCDP9Yoc__z8",
                authDomain: "scottdev-f6528.firebaseapp.com",
                projectId: "scottdev-f6528",
                storageBucket: "scottdev-f6528.appspot.com",
                messagingSenderId: "447730403122",
                appId: "1:447730403122:web:1727020dbac4ad4cf6f92b"
            };
        case "MedDBrieferDev":
            return {
                apiKey: "AIzaSyBqnEMwEstp4D7Mvtbw9OTAiNJ7qza0Ses",
                authDomain: "meddbriefer-dev.firebaseapp.com",
                projectId: "meddbriefer-dev",
                storageBucket: "meddbriefer-dev.appspot.com",
                messagingSenderId: "144940722070",
                appId: "1:144940722070:web:4de179ebb58d84a7679fb7"
            };
        default: //MedDBriefer (production)
            return  {
                apiKey: "AIzaSyBOgWAbXUGckpad2sk0IUo00hZsV4WxG0E",
                authDomain: "meddbriefer-68cd4.firebaseapp.com",
                projectId: "meddbriefer-68cd4",
                storageBucket: "meddbriefer-68cd4.appspot.com",
                messagingSenderId: "1087114796018",
                appId: "1:1087114796018:web:679fbab38dbf78af0ce96b",
                measurementId: "G-Q7QZKC9KHW"
            }
    }
}


const getApp = (appID) => {
    const matches = firebase.apps.filter(app => app.options.appId === appID)
    // console.log("matches", matches)
    return (matches.length === 1) ? matches[0] : null
}

const getOrInitializeApp = (appCfg) => {
    const app = getApp(appCfg.appId)
    // simply log which project is initialized (or about to be)
    console.log(`using ${appCfg.projectId}`)
    // console.log(`${appCfg.appId} already exists: ${!!app}`)
    return app ? app : firebase.initializeApp(appCfg, appCfg.projectId)
}

export function useFirebaseProject(projectName = "MedDBriefer") {
    // don't reinitialize app if it already exists
    //   projectName comes from App process.env.NX_FIREBASE_PROJECT
    //
    const projectConfig = getProjectConfig(projectName)
    const firebaseApp = getOrInitializeApp(projectConfig)
    return {
      auth: firebaseApp.auth(),
      db: firebaseApp.firestore()
    }
}

// to inject firebase app into child react components
export const FirebaseContext = React.createContext({
    auth: undefined,
    db: undefined
})

// for child react components to access the firebase app
export const useFirebase = () => useContext(FirebaseContext)
